import * as React from 'react';
import Helmet from 'react-helmet';
import CssBaseline from 'material-ui/CssBaseline';
import { MuiThemeProvider, withStyles, WithStyles } from 'material-ui';
require('typeface-roboto');
require('typeface-audiowide');

const theme = require('../utils/materialTheme');
import { TopNav } from '../components/features/TopNav';

const styles = {};

interface LayoutProps extends WithStyles<keyof typeof styles> {
  children: Function;
  data: {
    site: {
      siteMetadata: {
        title: string;
      };
    };
  };
}

export default withStyles(styles)(({ children, data }: LayoutProps) => (
  <React.Fragment>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[{ name: 'description', content: 'Sample' }, { name: 'keywords', content: 'sample, something' }]}
    />
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <main>
        <TopNav />
        <div>{children()}</div>
      </main>
    </MuiThemeProvider>
  </React.Fragment>
));

export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.tsx